<template>
  <Header12 />
  <div class="body">
    <section class="background-bleu">
      <MenuTitle title="Entretien annuel et professionnel" subTitle=""
        srcImg="/images/pages/conseil-rh/desc-picture.png" backgroundSpan="span-background-blue-long" />
    </section>
    <section>
      <NavLeft tab="entretien_annuel_professionnel" breadcrumb1="" breadcrumb2="Entretien annuel et professionnel" />
    </section>
    <section class="background-bleu">
      <Expertises />
    </section>
    <section>
      <NousContacter />
    </section>
    <section>
      <Footer :dark_bg="true" />
    </section>
  </div>
</template>

<script setup>
import Header12 from '~/components/common/Headers/Header-12.vue';
import Expertises from '@/components/emci/Homepage/Nos-expertises/index.vue';
import NousContacter from '@/components/emci/NousContacter/index.vue';
import Footer from '@/components/emci/Footer/index.vue'
import MenuTitle from "../../MenuTitle";
import NavLeft from "@/components/emci/NavLeft/index.vue"
useHead({
  title: "EMCI - Entretiens annuels et entretiens professionnels",
  meta: [
    {
      name: "description",
      content: "EMCI propose des formations à l’animation des entretiens et propose des accompagnements sur la réalisation des supports nécessaires."
    }
  ]
})
</script>

<style scoped>
.body {

  overflow: hidden !important;
  margin-top: 120px;
}

@media only screen and (min-width: 300px) and (max-width: 768px) {
  .body {
    margin-top: 85px;
  }

  .background-bleu {
    margin-bottom: 50px;
  }
}
</style>